import { render, staticRenderFns } from "./StacBrowser.vue?vue&type=template&id=798e7336"
import script from "./StacBrowser.vue?vue&type=script&lang=js"
export * from "./StacBrowser.vue?vue&type=script&lang=js"
import style0 from "./StacBrowser.vue?vue&type=style&index=0&id=798e7336&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports